import { render } from "./Silo3dComponent.vue?vue&type=template&id=f3ffcade&scoped=true"
import script from "./Silo3dComponent.vue?vue&type=script&lang=js"
export * from "./Silo3dComponent.vue?vue&type=script&lang=js"

import "./Silo3dComponent.vue?vue&type=style&index=0&id=f3ffcade&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ffcade"]])

export default __exports__